var map = {
	".": "ohLs",
	"./": "ohLs",
	"./01_executionReport": "pjpR",
	"./01_executionReport.json": "pjpR",
	"./02_ account_update": "5y10",
	"./02_ account_update.json": "5y10",
	"./index": "ohLs",
	"./index.js": "ohLs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UGH9";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/account ^.*$
// module id = UGH9
// module chunks = 3